import axionIns from "../axios";

const uploadFile = async (payload) => {
  return axionIns
    .post("uploads/uploadbase4", payload)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      console.log("err", JSON.stringify(error.response.data));
      return error?.response?.data ? error?.response?.data : { status: false };
    });
};

const uploadFileSingle = async (payload) => {
  const formData = new FormData();
  formData.append("file", payload); // 'file' key must match your backend field name

  return axionIns
    .post("uploads/singledocument", formData)
    .then((response) => {
      console.log({response});
      
      return response.data;
    })
    .catch((error) => {
      console.log("err", JSON.stringify(error.response.data));
      return error?.response?.data ? error?.response?.data : { status: false };
    });
};

export default {
  uploadFile,
  uploadFileSingle
};
